var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"eb6846cab216f043a4deeb3232c6b9a0544604d1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tours@smartrent"]={id:"eb6846cab216f043a4deeb3232c6b9a0544604d1"};
      